import { useEffect, useState } from "react";
import { FaEye, FaPen } from "react-icons/fa";
import { replaceUnderscore } from "../../../CommonFunction/common";
import Input from "../../Components/Input/Input";
import CardInputFields from "../CardInputFields/CardInputFields";
import DocumentuploadSection from "../DocumentuploadSection/DocumentuploadSection";
import "./FormInputSection.scss";
import { parseTheAdditionInfo } from "../../CommonFunction/parseTheAdditionInfo";
import Button from "../../Components/Button/Button";
const FormInputSection = ({
  LoadForm,
  fields,
  formikhandleInputChange,
  fielddata,
  errors,
  touched,
  handleBlur,
  TypeOfPortal,
  accountId,
  determineVisibility,
  determineDisability = (f) => {},
  formkey,
  setAllFieldsData = () => {},
  formik = {},
  formReference = {},
  Type = "",
  AllDynamicFunctions = {},
}) => {
  // console.log(formik, formReference);
  const [showFiles, setShowFiles] = useState(false);
  const [AccountData, setAccountData] = useState();
  // eslint-disable-next-line
  const [fieldsData, setfieldsData] = useState(fields);

  const ViewFiles = (e) => {
    setAccountData(e);
    setShowFiles(true);
  };

  useEffect(() => {
    // console.log(fields, Type);
    setfieldsData(fields);
  }, [fields]);
  // console.log(AccountData);
  return (
    <>
      {Type === "Documents" ? (
        <>
          <DocumentuploadSection
            LoadForm={LoadForm ? LoadForm : false}
            data={fieldsData}
            TypeOfPortal={TypeOfPortal}
            formkey={formkey}
            formReference={formReference}
            values={formik.values}
          />
        </>
      ) : (
        fieldsData?.map((element, i) => {
          //Parsing the Additional_Info and merging it with the element
          let parseData;
          if (element.Additional_Info && element.Additional_Info.trim()) {
            parseData = parseTheAdditionInfo(element);
          } else {
            parseData = element;
          }
          if (!determineVisibility(parseData)) {
            return null;
          }
          let e = determineDisability(parseData);
          // console.log(e);
          if (e.type === "CardInputFileds") {
            return (
              <div key={e.key}>
                <CardInputFields
                  data={e}
                  alldata={formik.values}
                  error={errors[e.name]}
                  handleBlur={handleBlur}
                  touched={touched[e.name]}
                  formikhandleInputChange={formikhandleInputChange}
                />
              </div>
            );
          }

          if (e.name === "Sidebyside") {
            if (e.value) {
              formikhandleInputChange();
            }
            return (
              <div key={e.id}>
                <div className="sidebyside" key={e.id}>
                  {e.Subfields.map((e, i, arr) => {
                    let sideBySideParse;
                    if (e.Additional_Info && e.Additional_Info.trim()) {
                      sideBySideParse = parseTheAdditionInfo(e);
                    } else {
                      sideBySideParse = e;
                    }
                    return (
                      <>
                        {e.Label ? <label className={`titleOfSideBySide`}>{replaceUnderscore(e.Label)}</label> : ""}
                        <div
                          key={sideBySideParse._id}
                          className={`${arr.length > 2 ? "Sidebysideinput3" : "Sidebysideinput"}`}
                        >
                          <Input
                            EMTQuery=""
                            checked={""}
                            InputConfig={sideBySideParse}
                            // field={props.text
                            name={sideBySideParse.name}
                            value={formik.values[sideBySideParse.name]}
                            label={sideBySideParse.label}
                            disabled={sideBySideParse.disabled}
                            type={sideBySideParse.type}
                            modalform={true}
                            Iconinside={true}
                            handleInputChange={(evt) => {
                              // consolsideBySideParse.log(evt);
                              formikhandleInputChange(evt);
                            }}
                            // handleInputChange={props.handleChange}
                            dropdowndata={sideBySideParse.dropdowncontent}
                            hasApiCallback={sideBySideParse.hasApiCallback}
                            error={errors[sideBySideParse.name]}
                            touched={touched[sideBySideParse.name]}
                            handleBlur={handleBlur}
                            Touch_inp={
                              errors[sideBySideParse.name] && touched[sideBySideParse.name] ? "error_input_touch" : ""
                            }
                            min={sideBySideParse.min}
                            max={sideBySideParse.max ? sideBySideParse.max : undefined}
                            formkey={formkey}
                            TypeOfPortal={TypeOfPortal}
                            fielddata={fielddata}
                            setAllFieldsData={setAllFieldsData}
                          />
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            );
          }
          if (e.type == "Button") {
            return (
              <div key={e.id} className={`ButtonInpParent`}>
                <Button action={() => AllDynamicFunctions?.[e.name]()} name="modalbutton" text={e.label} />
              </div>
            );
          }
          return (
            <>
              {/* {e.break && <br />} */}
              <div key={e.id} className={`inpParent ${e.break ? "new-line" : ""}`}>
                <Input
                  EMTQuery={e?.EMTQuery}
                  checked={""}
                  InputConfig={e}
                  // field={props.text}
                  name={e.name}
                  value={formik.values[e.name]}
                  label={
                    e.Is_Custom_Input ? (
                      <>
                        {e.label}
                        <FaPen
                          onClick={(event) => {
                            AllDynamicFunctions?.handleCustomForm(e);
                          }}
                          style={{ width: "10px", height: "10px", marginLeft: "5px", cursor: "pointer" }}
                        />
                      </>
                    ) : (
                      e.label
                    )
                  }
                  type={e.type}
                  modalform={true}
                  Iconinside={true}
                  handleInputChange={(evt) => {
                    // console.log(evt);
                    formikhandleInputChange(evt);
                  }}
                  // handleInputChange={props.handleChange}
                  disabled={
                    fielddata &&
                    Object.keys(fielddata).length > 0 &&
                    e.name === "CreateCSUser" &&
                    !fielddata?.CreateCSUserdisable
                      ? true
                      : e.disabled
                  }
                  handleBlur={handleBlur}
                  error={errors[e.name]}
                  touched={touched[e.name]}
                  Touch_inp={errors[e.name] && touched[e.name] ? "error_input_touch" : ""}
                  dropdowndata={e.dropdowncontent || e.dropdowndata}
                  hasApiCallback={e.hasApiCallback}
                  min={e.min}
                  max={e.max ? e.max : undefined}
                  formkey={formkey}
                  TypeOfPortal={TypeOfPortal}
                  fielddata={fielddata}
                  setAllFieldsData={setAllFieldsData}
                />
              </div>

              {((formik.values?.Is_Verified && e.name === "Is_Verified") ||
                (formik.values?.Is_Aadhar_Verified && e.name === "Is_Aadhar_Verified") ||
                (formik.values?.Is_Pan_Verified && e.name === "Is_Pan_Verified") ||
                (formik.values?.Not_Intrested && e?.name === "Not_Intrested") ||
                (formik.values?.Is_Gst_Verified && e?.name === "Is_Gst_Verified")) && (
                <FaEye
                  id={e.name}
                  className="EyeIcon"
                  onClick={() => {
                    formReference?.current?.OpenReviewModal(e);
                    ViewFiles(e);
                  }}
                />
              )}
            </>
          );
        })
      )}
      {showFiles &&
        (AccountData.name === "Is_Pan_Verified" ||
          AccountData.name === "Is_Aadhar_Verified" ||
          AccountData.name === "Is_Verified" ||
          AccountData.name === "Not_Intrested" ||
          AccountData.name === "Is_Gst_Verified") && (
          <>
            {/* // <ViewVendorFiles
          //   Values={formReference?.current?.Remarks?.values}
          //   show={true}
          //   TypeOfPortal={TypeOfPortal}
          //   setShowModal={() => setShowFiles(false)}
          //   accountId={accountId || fielddata?._id}
          //   Type={
          //     AccountData.name === "Is_Pan_Verified"
          //       ? "PAN"
          //       : AccountData.name === "Is_Gst_Verified"
          //       ? "GST"
          //       : AccountData.name === "Is_Aadhar_Verified"
          //       ? "Aadhaar"
          //       : AccountData.name === "Is_Verified"
          //       ? "verified"
          //       : AccountData.name === "Not_Intrested"
          //       ? "Not_Intrested"
          //       : "Bank"
          //   }
          // /> */}
          </>
        )}
    </>
  );
};

export default FormInputSection;
